module.exports = __webpack_public_path__ + "static/img/otLogohf2.7382431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/otLogohf2.png
// module id = NCu9
// module chunks = 44